const actions = {
  FETCH_UPDATE_PACKAGES: 'FETCH_UPDATE_PACKAGES',
  FETCH_UPDATE_PACKAGES_SUCCESS: 'FETCH_UPDATE_PACKAGES_SUCCESS',
  FETCH_UPDATE_PACKAGES_ERROR: 'FETCH_UPDATE_PACKAGES_ERROR',

  fetchUpdatePackages: (search) => ({
    type: actions.FETCH_UPDATE_PACKAGES,
    search,
  }),

  fetchUpdatePackagesSuccess: (packages) => ({
    type: actions.FETCH_UPDATE_PACKAGES_SUCCESS,
    packages,
  })
};

export default actions;
